import {UserGender} from '../../backend/enums/user-gender';
import {translations} from '../../i18n/translations';

/**
 * Array with the available genders in the Backend.
 *
 * Note: The property 'translation' gives the translation path to be used with i18n.
 * Example: t(genders[0].translation)
 * We don't return the translated value, because once set the values won't change.
 * Thus, if the user updates his language on the profile, the values given by this
 * array won't change and translate to the new language set by the user.
 */
export const genders: Array<{translation: string; type: UserGender}> = [
  {translation: translations.genders[UserGender.Female], type: UserGender.Female},
  {translation: translations.genders[UserGender.Male], type: UserGender.Male},
  {
    translation: translations.genders[UserGender.Unspecified],
    type: UserGender.Unspecified,
  },
  {
    translation: translations.genders[UserGender.Undisclosed],
    type: UserGender.Undisclosed,
  },
];
